import { captureAttribution } from './attribution';
import { initDataLayer } from './gtm';
import { initTrackingId } from './identity';

export function initTracking() {
  if (typeof window === 'undefined') return;
  initDataLayer();
  initTrackingId();
  captureAttribution();
}
